<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="formCol">
                <v-select v-model="user.civilite" no-data-text="N/C" :items="civilite" :label="civilite_label" hide-details></v-select>
            </v-col>
            <v-col cols="12" class="formCol">
                <v-text-field v-model="user.nom" :label="nom_label" hide-details required></v-text-field>
            </v-col>
            <v-col cols="12" class="formCol">
                <v-text-field v-model="user.prenom" :class="errorForm ? 'errorField' : ''" :label="prenom_label" hide-details required></v-text-field>
            </v-col>
            <v-col cols="12" class="formCol">
                <label class="tel-input-label" :class="labelmobile">{{mobile_label}}</label>
                <vue-tel-input v-model="user.telephone_mobile" @input="changeNumberMobile" :class="labelmobile" @focus="labelmobile = 'active'" @blur="user.telephone_mobile != '' ? labelmobile = 'active agrey' :  labelmobile = ''" mode="national" :placeholder="''" :valid-characters-only="true" :onlyCountries="['FR', 'BE', 'IT']"></vue-tel-input>
            </v-col>
            <v-col cols="12" class="formCol">
                <label class="tel-input-label" :class="labelfixe">{{fixe_label}}</label>
                <vue-tel-input v-model="user.telephone_fixe" ref="fixe" @input="changeNumberFixe" :class="labelfixe" @focus="labelfixe = 'active'" @blur="user.telephone_fixe != '' ? labelfixe = 'active agrey' :  labelfixe = ''" mode="national" :placeholder="''" :valid-characters-only="true" :onlyCountries="['FR', 'BE', 'IT']"></vue-tel-input>
                <!-- <v-text-field v-model="user.telephone_fixe" :label="fixe_label" hide-details required></v-text-field> -->
            </v-col>
            <v-col cols="12" class="formCol">
                <v-text-field v-model="user.email" :label="email_label" hide-details required></v-text-field>
            </v-col>
            <v-col cols="12" class="formCol">
                <v-select v-model="user.langue_preferee" :class="errorForm ? 'errorField' : ''" :items="langs" item-text="langue" item-value="val" :label="lang_label" hide-details></v-select>
            </v-col>
            <v-col cols="12" class="formCol">
                <v-text-field v-model="user.adresse.rue1" :label="adresse_label" hide-details required></v-text-field>
            </v-col>
            <v-col cols="12" class="formCol">
                <v-text-field v-model="user.adresse.rue2" :label="complement_label" hide-details required></v-text-field>
            </v-col>
            <v-col cols="12" class="formCol">
                <v-text-field v-model="user.adresse.code_postal" :label="codepostal_label" hide-details required></v-text-field>
            </v-col>
            <v-col cols="12" class="formCol">
                <v-text-field v-model="user.adresse.ville" :label="ville_label" hide-details required></v-text-field>
            </v-col>
            <v-col cols="12" class="formCol">
                <v-textarea
                    name="input-7-1"
                    :label="commentaire_label"
                    v-model="user.commentaire"
                    hide-details 
                ></v-textarea>
            </v-col>
            <v-col cols="6">
                <v-btn rounded color="grey" dark depressed @click="cancelForm">Annuler</v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
                <v-btn rounded color="primary" depressed @click="recordLead">{{$t('messages.leadform.enregistrer')}}</v-btn>
            </v-col>
            <v-col cols="12" v-if="errorForm">
                <span class="errorForm">
                    {{$t('messages.leadform.error')}}
                </span>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    props: ['lead'],
     data() {
        return {
            civilite: ["Mr", "Mme"],
            langs: [
                {langue: 'Français', val:'FR'},
                {langue: 'Italien', val:'IT'},
                {langue: 'Néerlandais', val:'NL'}
            ],
            errorForm:false,
            user: {},
            userMobile: "",
            userFixe: "",
            labelmobile:"",
            labelfixe: "",
        }
    },
    methods: {
        changeNumberMobile(evt, phoneObject){
            if(phoneObject.isValid){
                this.userMobile = phoneObject.number.e164;
            }
        },
        changeNumberFixe(evt, phoneObject){
            if(phoneObject.isValid){
                this.userFixe = phoneObject.number.e164;
            }
        },
        cancelForm(){
            this.$emit('cancelForm')
        },
        recordLead(event){
            this.errorForm = false;
            if(this.user.langue_preferee == "" || this.user.prenom == ""){
                this.errorForm = true;
            } else {
                this.user.telephone_mobile = this.userMobile;
                this.user.telephone_fixe = this.userFixe;
                this.$emit('recordLead', this.user)
            }
        }
    },
    created: function() {
        this.user = Object.assign({}, this.lead);
        this.userMobile = this.user.telephone_mobile;
        this.userFixe = this.user.telephone_fixe;
        if(this.user.telephone_mobile != ""){
            this.labelmobile = 'active agrey'
        }
        if(this.user.telephone_fixe != ""){
            this.labelfixe = 'active agrey'
        }
    },
    computed: {
        civilite_label: function(){
            return this.$t('messages.leadform.civilite');
        },
        nom_label: function(){
            return this.$t('messages.leadform.nom');
        },
        prenom_label: function(){
            return this.$t('messages.leadform.prenom')+"*";
        },
        mobile_label: function(){
            return this.$t('messages.leadform.mobile');
        },
        fixe_label: function(){
            return this.$t('messages.leadform.fixe');
        },
        email_label: function(){
            return this.$t('messages.leadform.email');
        },
        lang_label: function(){
            return this.$t('messages.leadform.lang')+"*";
        },
        adresse_label: function(){
            return this.$t('messages.leadform.adresse');
        },
        complement_label: function(){
            return this.$t('messages.leadform.complement');
        },
        codepostal_label: function(){
            return this.$t('messages.leadform.codepostal');
        },
        ville_label: function(){
            return this.$t('messages.leadform.ville');
        },
        commentaire_label: function(){
            return this.$t('messages.leadform.commentaire');
        }
    },
}
</script>
<style lang="scss">
    .formCol {
        padding:4px 12px;
        position:relative;
    }
    .errorForm {
        color:red;
        font-weight: 700;
        font-size:0.8em;
    }
    .errorField {
        .v-input__control > .v-input__slot:before {
            border-color: red !important;
        }
        
    }
    .vue-tel-input {
        border:0 !important;
        border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
        border-radius: 0px !important;
        padding-top: 12px !important;
        margin-top: 4px !important;
        transition:all ease 0.2s;
        &:active,
        &:focus,
        &:focus:active {
            background-image: none !important;
            outline: 0 !important;
            box-shadow: none !important;
            
        }
        &.active {
            border-bottom: 2px solid #eb566b !important;
            &.agrey {
                border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
            }
        }
    }
    .tel-input-label {
        position:absolute;
        bottom:9px;
        left: 75px;
        pointer-events: none;
        color: rgba(0, 0, 0, 0.6);
        transition:all ease 0.2s;
        &.active {
            color:#eb566b;
            left:-3px;
            transform:translateX(0px) translateY(-22px) scale(0.75);
            &.agrey {
                color: rgba(0, 0, 0, 0.6);
            }
        }
    }
</style>